var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceMv = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "service_mv_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#service_mv_svg__a)",
  "data-name": "Group 116"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Polygon 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M50.503 32.462a4.39 4.39 0 0 0-2.26-3.869L19.622 10.578A4.44 4.44 0 0 0 13 14.445v36.032a4.44 4.44 0 0 0 6.622 3.868L48.243 36.33a4.39 4.39 0 0 0 2.26-3.868",
  "data-name": "Path 184"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M31.867 28.601a4.441 4.441 0 1 0-6.115 4.1l-1.147 6.877h5.647l-1.146-6.877a4.44 4.44 0 0 0 2.761-4.1",
  "data-name": "Path 185"
}))));
export { SvgServiceMv as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBkPSJNMCAwaDY0djY0SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PGcgZGF0YS1uYW1lPSJHcm91cCAxMTYiIGNsaXAtcGF0aD0idXJsKCNhKSI+PGcgZGF0YS1uYW1lPSJQb2x5Z29uIDEiPjxwYXRoIGRhdGEtbmFtZT0iUGF0aCAxODQiIGQ9Ik01MC41MDMgMzIuNDYyYTQuMzg5IDQuMzg5IDAgMDAtMi4yNi0zLjg2OUwxOS42MjIgMTAuNTc4QTQuNDQxIDQuNDQxIDAgMDAxMyAxNC40NDV2MzYuMDMyYTQuNDQxIDQuNDQxIDAgMDA2LjYyMiAzLjg2OEw0OC4yNDMgMzYuMzNhNC4zODkgNC4zODkgMCAwMDIuMjYtMy44NjgiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiLz48L2c+PHBhdGggZGF0YS1uYW1lPSJQYXRoIDE4NSIgZD0iTTMxLjg2NyAyOC42MDFhNC40NDEgNC40NDEgMCAxMC02LjExNSA0LjFsLTEuMTQ3IDYuODc3aDUuNjQ3bC0xLjE0Ni02Ljg3N2E0LjQzOSA0LjQzOSAwIDAwMi43NjEtNC4xeiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPjwvZz48L3N2Zz4=";